import { render, staticRenderFns } from "./CallHistoryLogUser.vue?vue&type=template&id=076959d3&"
import script from "./CallHistoryLogUser.vue?vue&type=script&lang=ts&"
export * from "./CallHistoryLogUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports